import RestService from '../services/rest';

async function getLotInfo() {
  return RestService.getAuthenticated('lots/info');
}

async function getLots(branchCode) {
  return RestService.getAuthenticated('lots/allBranch', { branchCode });
}

async function getOptionsLots(branchCode) {
  return RestService.getAuthenticated('lots/options', { branchCode });
}

async function generateLots(branchCode, quantity, initial, prefix) {
  return RestService.postAuthenticated('lots/create', {
    branchCode, quantity, initial, prefix,
  });
}

export default {
  getLotInfo,
  getLots,
  getOptionsLots,
  generateLots,
};
